<template>
  <div class="selectSolutionSlide">
    <div class="text-center mb-3 subTextContainer">
      {{ modalText }}
      <v-btn
        small
        dark
        class="showAllSolutionsBtn"
        color="orange"
        style="float: right;"
        @click="
          guibus_publish('dispatch:beacon', {
            eventId: `welcome-solution_selector_browse_solutions_button-click${
              isMobileSized ? '-mobile' : ''
            }`,
          })
          showAllSolutionsModal = true
        "
        >Browse Solutions</v-btn
      >
    </div>
    <div class="d-flex justify-center">
      <div v-if="isLoadingThumbnails" class="d-flex solutionThumbnailsLoadingIndicator">
        <v-progress-circular
          :size="100"
          :width="8"
          indeterminate
          color="blue darken-2"
        ></v-progress-circular>
      </div>
      <div
        v-else
        class="d-flex justify-center solutionsDisplay"
        :class="{ mobileSolutionsDisplay: isMobileSized }"
      >
        <SolutionThumbnail
          v-for="thumbnail in solutionThumbnails"
          :key="thumbnail.campaignSolutionId"
          :thumbnail="thumbnail"
          :isSelected="thumbnail.campaignSolutionId === selectedSolutionId"
          @handle-thumbnail-click="handleThumbnailClick"
        />
      </div>
    </div>
    <div class="text-right mt-4">
      <v-btn
        v-if="isModal"
        dark
        class="grey lighten-1 ml-3"
        @click="
          guibus_publish('dispatch:beacon', {
            eventId: `welcome-solution_selector_cancel_button-click${
              isMobileSized ? '-mobile' : ''
            }`,
          })
          $emit('closeModal')
        "
        >Cancel</v-btn
      >
    </div>
    <!-- Campaign Solutions Modal -->
    <ModalWrapper
      v-model="showAllSolutionsModal"
      femsName="campaign-solutions"
      femsVersion="v1"
      :aEvents="campaignSolutionsAEvents"
      :modalDataSet="campaignSolutionsModalDataSet"
      :fromBottom="true"
    />
  </div>
</template>

<script>
import SolutionThumbnail from './SolutionThumbnail'
import ModalWrapper from 'component-modal-wrapper'

export default {
  components: {
    SolutionThumbnail,
    ModalWrapper,
  },
  props: {
    solutionThumbnails: {
      type: Array,
      required: true,
    },
    isLoadingThumbnails: {
      type: Boolean,
      default: true,
    },
    modalText: {
      type: String,
      default: '',
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: String,
      default: undefined,
    },
    subVertical: {
      type: String,
      default: undefined,
    },
    mode: {
      type: String,
      default: 'static',
    },
    isQuickStart: {
      type: Boolean,
      default: false,
    },
    isShopifyUser: {
      type: Boolean,
      default: false,
    },
    currentSolutionId: {
      type: Number,
      default: undefined,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedSolutionId: this.currentSolutionId
        ? this.currentSolutionId
        : this.solutionThumbnails[0]?.campaignSolutionId || undefined,
      showAllSolutionsModal: false,
      campaignSolutionsAEvents: [
        {
          eventName: 'quickStartSolutionSelectionConfirmation',
          callback: (modalWrapperObj, payload) => {
            // modalWrapper structure returns the modalWrapper object as the first argument and the payload as the second
            // modalWrapper object is not used in this case
            this.guibus_publish('dispatch:beacon', {
              eventId: `welcome-solution_selector_select_library_solution_${
                payload.campaignSolutionId
              }_and_next_button-click${this.isMobileSized ? '-mobile' : ''}`,
            })
            if (payload.adType !== this.mode) {
              this.$emit('changeMode', payload.adType)
            }
            this.$emit('selectSolutionAndContinue', payload.campaignSolutionId)
            this.$emit('closeModal')
            this.showAllSolutionsModal = false
          },
        },
        {
          eventName: 'cancelCampaignSolutionsModal',
          callback: () => {
            this.showAllSolutionsModal = false
          },
        },
      ],
    }
  },
  methods: {
    handleThumbnailClick(solutionId) {
      this.selectedSolutionId = solutionId
      this.$emit('selectSolution', this.selectedSolutionId)
      if (this.isModal) {
        this.$emit('selectSolution', this.selectedSolutionId)
      }
    },
  },
  watch: {
    solutionThumbnails: {
      handler() {
        this.selectedSolutionId =
          this.currentSolutionId || this.solutionThumbnails[0]?.campaignSolutionId
        this.$emit('selectSolution', this.selectedSolutionId)
      },
      deep: true,
    },
  },
  computed: {
    campaignSolutionsModalDataSet() {
      return {
        isPersistent: true,
        noClickAnimation: true,
        width: 1100,
        isModal: true,
        isQuickStart: true,
        isShopifyQuickstartUser: this.isShopifyUser,
        vertical: this.vertical,
        subVertical: this.subVertical,
        mode: this.mode,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.selectSolutionSlide {
  width: 100%;
  background-color: white;
  border-radius: 50px;
  padding: 30px;
  .subTextContainer {
    position: relative;
    height: 24px;
    .showAllSolutionsBtn {
      position: absolute;
      right: 0;
    }
  }
  .solutionsDisplay {
    &.mobileSolutionsDisplay {
      flex-direction: column;
    }
  }
  .solutionThumbnailsLoadingIndicator {
    height: 150px;
    width: 300px;
    justify-content: center;
    align-items: center;
  }
}
</style>
